// extracted by mini-css-extract-plugin
export default {"socials":"socials__socials__hJZS1","social":"socials__social__eG7Cv","icon":"socials__icon__udGoh","navOpen":"socials__navOpen__ziCwP"};